
import { gql } from "@apollo/client";

export const GET_SHOP = gql`
query GetShop($filter: ShopFilter!) {
  getShop(filter: $filter) {
    id
    name
    description
    contactEmail
    email
    currency
    slug
    primaryDomain
    sokoWorldDomain
    customDomains
    hasBeenSetup
    isActive
    shopTags
    createdAt
    updatedAt
    avatar
    country
    coverImage
    deliveryOption
    deliveryAgent
    paymentOptions
    url
    shortUrl
    phone
    ownerId
    supplierId
    shopId
    locations {
      id
      lat
      long
      createdAt
      updatedAt
    }
  }
}
`

export const GET_COLLECTION_PRODUCTS = gql`
query GetCollectionProducts($filter: CatalogFilter, $pagination: Pagination) {
  getCollectionProducts(filter: $filter, pagination: $pagination) {
    sku
    discount {
      id
      type
      valid_country
      code
      percentage
      amount
      description
      is_draft
      start_date
      expiry_date
      redemptions_limit
      product_condition
      products
      fixed_amount_allocation
      created_at
      updated_at
      created_by
      user_id
      has_expired
      number_of_times_used
      locations
      locations_tagname
    }
    id
    title
    productType
    limited_stock
    qty
    main_stock
    instantDelivery
    minimumOrderQuantity
    maximumDeliveryTime
    minimumDeliveryTime
    distributionChannels
    transit_stock
    price
    supplier_cost
    profit_added
    currency
    country
    description
    extra_information
    combination_string
    published
    inhouse
    attended_to
    verified
    cost_price
    weight
    avatar
    categories {
      id
      name
      type
      description
      isActive
      avatar
      children {
        id
        name
        type
        description
        isActive
        avatar
        parent
      }
      parent
    }
    variations {
      id
      variation_name
      variation_options {
        id
        variation_value
      }
    }
    tags
    combinations {
      id
      sku
      price
      available_stock
      combination_string
    }
    media {
      id
      avatar
      product_id
    }
    shop_id
    comments {
      id
      staff_number
      message
      created_at
      updated_at
    }
    resell
    uuid
    likesCount
    savesCount
    digitalDetails
    sharesCount
    supplier_id
    product_origin
    created_at
    updated_at
    status
    overalReview
    reviews {
      id
      rating
      comment
      user_id
    }
    reviewBreakDown {
      totalReviews
      breakDown {
        poor
        average
        good
        veryGood
        excellent
      }
    }
    supplier {
      id
      supplier_type
      permissions
      shop {
        id
        name
        description
        contactEmail
        email
        currency
        slug
        primaryDomain
        sokoWorldDomain
        customDomains
        hasBeenSetup
        isActive
        shopTags
        createdAt
        updatedAt
        avatar
        country
        coverImage
        deliveryOption
        deliveryAgent
        locations {
          id
          lat
          long
          createdAt
          updatedAt
        }
        paymentOptions
        url
        shortUrl
        phone
        ownerId
        supplierId
        shopId
      }
      name
      email
      phone
      country
      avatar
      disabled
      business_details {
        id
        supplier_id
        business_name
        business_address
        industry
        description
        logo
        registered
        email
        phone
        city
        state
        postal_code
        delivery_option
        supplier_business_verified
        country
        documents {
          id
          business_id
          document_name
          document
        }
      }
      has_verified_phonenumber
      has_verified_email
      setup_complete
      generic_name
      payment_details {
        id
        supplier_id
        account_name
        account_number
        provider
        method
      }
      device_token
      setupConfig {
        supplier_id
        hasCategories
        hasProducts
        hasTerms
        hasPaymentMethod
      }
      agreement_terms
      social_platform
      social_platform_token
      has_accepted_terms
      createdAt
      deletedAt
    }
  }
}
`

export const GET_SHOP_COLLECTION =gql`
query GetShopCollection($filter: ShopCollectionFilter!) {
  getShopCollection(filter: $filter) {
    id
    name
    banner
    is_active
  }
}
`

export const GET_SHOP_COLLECTIONS =gql`
query GetShopCollections($filter: ShopCollectionFilter, $pagination: Pagination) {
  getShopCollections(filter: $filter, pagination: $pagination) {
    id
    name
    banner
    is_active
  }
}
`

export const GET_SHOP_COLLECTIONS_LENGTH= gql`
query Query($filter: ShopCollectionFilter) {
  getShopCollectionsLength(filter: $filter)
}
`

export const GET_SHOP_COLLECTION_PRODUCTS = gql`
query GetShopCollectionProducts($filter: ShopCollectionProductsFilter!) {
    getShopCollectionProducts(filter: $filter) {
        id
        title
        sku
        qty
        price
        profit_added
        currency
        country
        description
        combination_string
        published
        inhouse
        attended_to
        verified
        cost_price
        avatar
        shop_id
        resell
        uuid
        supplier_id
        extra_information
        instantDelivery
        resell
        productType
        categories {
            id
        }
        supplier {
            id
            name
            generic_name
        }
        discount {
            id
            type
            valid_country
            code
            percentage
            amount
            has_expired
            locations
            fixed_amount_allocation
        }
    }
}
`


export const GET_SHOP_PRODUCTS = gql`
query GetShopProducts($shopId: ID!) {
  getShopProducts(shop_id: $shopId) {
    title
    price
    id
    avatar
    profit_added
    currency
    description
  }
}
`
export const GETSALES= gql`
query GetSales($filter: SalesFilter) {
  getSales(filter: $filter) {
    id
    product_cost
    profit_added
    order_value
    supplier_id
    reseller_id
    order_date
    created_at
    updated_at
    sku
    country
    currency
    payment_reference
    order_id
    product_price
  }
}`